import React from 'react';
import './footer.css';
import { FaTelegramPlane, FaWhatsapp } from 'react-icons/fa';

const Footer = () => {
    return (
        <footer className='footerBack'>
            <div className="footer_container">
                {/* Левая часть - контакты */}
                <div className="contacts">
                    <div className='mail'>
                        Почта для связи: archmiplan@gmail.com
                    </div>
                    <div className='phoneNumber'>
                        Номер телефона: +7 988 206-96-39
                    </div>
                </div>
                
                {/* Центр - иконки мессенджеров */}
                <div className='messangers'>
                    <a className='telegrammIcon' href="https://t.me/+taYiWcp4vAo4OGIy" target="_blank" rel="noopener noreferrer">
                        <FaTelegramPlane className='telegrammIcon' color="#fcfafaff" />
                    </a>
                    <a className='whatsapIcon' href="https://wa.me/+79882069639" target="_blank" rel="noopener noreferrer">
                        <FaWhatsapp className='whatsapIcon' color="#f7f9f8ff" />
                    </a>
                </div>
                
                {/* Правая часть - адрес */}
                <div className='address'>
                    Наш офис находится в Махачкале по адресу: 
                    <br />
                    <br />
                    ул. Магомеда Гаджиева, 73А
                </div>
            </div>
        </footer>
    )
}

export default Footer